import { ctaBlockFragment } from 'humanity/components/ctaBlock/ctaBlock.fragment';

export const ctaBlockById = (id, preview = false) => `
  query {
    ctaBlock(id: "${id}", preview: ${preview}) {
      ${ctaBlockFragment}
    }
  }
`;
